export const chevron_right = () => (
  <path
    d="M9 18l6-6-6-6"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
